import { AppEntities } from "../../../config/entities";
import { NFLookupCatalog } from "./NFLookupCatalog";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";
import { NFLookupDocument } from "./NFLookupDocument";
interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupPaymentRequests = ({
  title,
  fieldName,
  required,
  showBorder,
  width,
  selectedCatalog,
  setSelectedCatalog,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.PaymentRequests.getDataService().GetAllCustomers(
      searchText
    );
  };

  return (
    <>
      <NFLookupDocument
        fieldName={fieldName}
        title={title}
        entity={AppEntities.PaymentRequests}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        width={width}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"id"} />
        <NFLookupCatalogColumn
          fieldName={"documentNumber"}
          caption={"documentNumber"}
        />
      </NFLookupDocument>
    </>
  );
};
